/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client/core';

export const FETCH_PROFILE_COMPLETENESS = gql`
  query ProfileCompleteness {
    profileCompleteness {
      profileCompletenessScore
      profileCareType
      steps {
        isComplete
        percentageOfTotal
        attributeType
        title
        description
      }
    }
  }
`;
